import { SolutionDTO } from '@luminovo/api-contracts';

import { Solution } from '../types';

export const parseSolution = (solution: SolutionDTO): Solution => {
    return {
        solutionTags: solution.tags,
        availability: solution.availability,
        quantities: solution.quantities,
        cost: solution.cost,
        unit: solution.offer_price.offer_unit,
        quantity: solution.offer_price.offer_quantity,
        offerUnitPrice: solution.offer_price.offer_unit_price,
        offerIdAndSignature: solution.offer_id_and_signature,
    };
};
